import { useState } from "react";
import "./BookingForm.css";
import { useNavigate } from "react-router-dom";

export default function BookingForm({bookedTimes, dispatchBook}) {
  const availableOccasions = ['Birthday', 'Anniversary'];
  const initResDate = new Date().toISOString().substring(0, 10);
  function availableTimes(resDate) {
    return [17, 18, 19, 20, 21, 22].filter(time => !bookedTimes?.get(resDate)?.includes(time));
  }
  const [formState, setFormState] = useState({
    resDate: initResDate,
    resTime: availableTimes(initResDate)[0],
    guestsCount: 1,
    occasion: availableOccasions[0],
  });
  const navigate = useNavigate();

  function handleChange(e) {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value,
    });
  }

  function handleSubmit(e) {
    e.preventDefault();
    dispatchBook({
      type: 'book',
      resDate: formState.resDate,
      resTime: Number(formState.resTime),
    });
    navigate('/booking-confirmation');
  }

  return (
    <form className="booking-form" onSubmit={handleSubmit}>
      <label htmlFor="res-date">Choose date</label>
      {formState.resDate === '' && <p className="font-description font-error">Please select a date.</p>}
      {availableTimes(formState.resDate).length === 0 && <p className="font-description font-error">This date is fully booked. Please select another.</p>}
      <input type="date" id="res-date" name="resDate" value={formState.resDate} onChange={handleChange} required />
      <label htmlFor="res-time">Choose time</label>
      <select id="res-time " name="resTime" value={formState.resTime} onChange={handleChange} required>
          {
            availableTimes(formState.resDate).map(time => (
              <option key={time} value={time}>{time}.00</option>
            ))
          }
      </select>
      <label htmlFor="guests">Number of guests</label>
      {! (formState.guestsCount > 0) && <p className="font-description font-error">The minimum value is 1 guest.</p>}
      <input type="number" placeholder="1" min="1" max="10" id="guests" name="guestsCount" value={formState.guestsCount} onChange={handleChange} required />
      <label htmlFor="occasion">Occasion</label>
      <select id="occasion" name="occasion" value={formState.occasion} onChange={handleChange} required>
          <option>Birthday</option>
          <option>Anniversary</option>
      </select>
      <input type="submit" value="Make Your reservation"
        disabled={availableTimes(formState.resDate).length === 0 || ! (formState.guestsCount > 0) || formState.resDate === ''}/>
      {/* <pre>formState={JSON.stringify(formState)}</pre>
      <pre>bookedTimes={JSON.stringify(bookedTimes)}</pre>
      <pre>availableTimes={JSON.stringify(availableTimes)}</pre> */}
    </form>
  );
}